import { render, staticRenderFns } from "./FormStep1.vue?vue&type=template&id=b4f0ec40&scoped=true&"
import script from "./FormStep1.vue?vue&type=script&lang=js&"
export * from "./FormStep1.vue?vue&type=script&lang=js&"
import style0 from "./FormStep1.vue?vue&type=style&index=0&id=b4f0ec40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f0ec40",
  null
  
)

/* custom blocks */
import block0 from "./FormStep1.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports